
















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class CalendarSinglePicker extends Vue {
  @Prop({ default: "label" }) readonly label!: string;
  @Prop({ default: "label" }) readonly date!: string | Date;

  private dateSeletedFormatDate: any = "";
  private dateSeleted: any = "";
  private isShowDropdownCalendar = false;
  private addClassHidden = false;

  @Watch("date", { immediate: true })
  dateChange(newVal: any, oldVal: any) {
    const newValDate = new Date(newVal).ToDateJsonString();
    const oldValDate = new Date(this.dateSeletedFormatDate).ToDateJsonString();
    if (newValDate !== oldValDate) {
      this.SetDateDefaults();
    }
  }

  @Watch("isShowDropdownCalendar")
  isShowCalendarChanged(newVal: any, oldVal: any) {
    this.ToggleBodyOverFlow(newVal);
  }

  public SeletedDate() {
    this.dateSeletedFormatDate = this.dateSeleted.GetDateFormat();
    this.$emit("update:date", this.dateSeleted.ToDateJsonString());
    this.$emit("change");
    this.HiddenOptionList();
  }

  public SetDateDefaults() {
    if (this.date) {
      const date = new Date(this.date);
      if (date instanceof Date) {
        this.dateSeleted = date;
        this.dateSeletedFormatDate = date.GetDateFormat();
      }
    }
  }

  public ToggleShowCalendar() {
    this.isShowDropdownCalendar = this.isShowDropdownCalendar ? false : true;
  }

  public ToggleBodyOverFlow(value: boolean) {
    const showBgModalList = document.querySelectorAll(".showBgModal");
    const el = document.body;
    if (value) {
      el.style.overflow = "hidden";
      showBgModalList.forEach((item: any) => {
        item.style.display = "block";
      });
    } else {
      el.style.overflow = "auto";
      showBgModalList.forEach((item: any) => {
        item.style.display = "none";
      });
    }
  }

  public HiddenOptionList() {
    this.addClassHidden = true;
    setTimeout(() => {
      this.isShowDropdownCalendar = false;
      this.addClassHidden = false;
    }, 300);
  }
}
